import { render } from "./retailGoods.vue?vue&type=template&id=5718f866&scoped=true"
import script from "./retailGoods.vue?vue&type=script&lang=js"
export * from "./retailGoods.vue?vue&type=script&lang=js"

import "./retailGoods.vue?vue&type=style&index=0&id=5718f866&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "E:\\aliPro\\platformpro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5718f866"]])

export default __exports__